import Papa from 'papaparse'
import { DxfParser, type IEntity } from 'dxf-parser'

const handleCsv = (file: File): Promise<{ x: number, y: number }[]> => {
  return new Promise((resolve, reject) => {
    Papa.parse<number[]>(file, {
      skipEmptyLines: true,
      complete: (results) => {
        const coordinates = results.data.map(d => ({ x: Number(d[0]), y: Number(d[1]) }))
        resolve(coordinates)
      },
      error: (error) => {
        console.error('Papa Parse error:', error)
        reject(error)
      },
    })
  })
}

const handleDxf = async (file: File): Promise<{ x: number, y: number }[]> => {
  const fileText = await file.text()
  const parser = new DxfParser()
  const parsedDxf = parser.parseSync(fileText)

  const points = parsedDxf?.entities
    .filter(e => e.type === 'POINT')
    .map(e => (e as IEntity & { position: { x: number, y: number } }).position)

  return points || []
}

export const parsePositioningFile = async (file: File): Promise<{ x: number, y: number }[]> => {
  const normalizedFileName = file.name.toLowerCase()
  if (file.type === 'text/csv' || normalizedFileName.endsWith('.csv')) {
    return handleCsv(file)
  }
  else if (file.type === 'text/dxf' || normalizedFileName.endsWith('.dxf')) {
    return handleDxf(file)
  }

  throw new Error('Unsupported file type')
}
